function proportion_format(s) {
	return (s * 100).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0];
}

function concentration(min, max, concentration_unit) {
	let out;
	if(min === undefined && max === undefined) {
		return '';
	} else if(concentration_unit === 'proportion') {
		concentration_unit = '%';
		if(min === undefined) {
			out = proportion_format(max);
		} else if(max === undefined || min === max) {
			out = proportion_format(min);
		} else {
			out = proportion_format(min) + ' - ' + proportion_format(max);
		}
	} else if(min === undefined) {
		out = max;
	} else if(max === undefined || min === max) {
		out = min;
	} else {
		out = min + ' - ' + max;
	}
	return out + ' ' + concentration_unit;
}

const frequencies = [
	'daily / weekly',
	'monthly / rarely'
];
const feels = [
	'Uplifted',
	'Balanced',
	'Relaxed'
];
const formats = [
	['Flower'],
	['Preroll'],
	['Oil', 'Capsule']
];

export { concentration, frequencies, feels, formats }